import React from "react"
import "./kevents.css"
import templeevent from "../../data/templevent.json";

function getNextDayOfTheWeek(dayName, excludeToday = true, refDate = new Date()) {
    const dayOfWeek = ["sun","mon","tue","wed","thu","fri","sat"]
                      .indexOf(dayName.slice(0,3).toLowerCase());
    if (dayOfWeek < 0) return;
    refDate.setHours(0,0,0,0);
    refDate.setDate(refDate.getDate() + +!!excludeToday + 
                    (dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7);
    return refDate;
}

function Kevents() {
    var sundaydt = getNextDayOfTheWeek("sunday", true, new Date()).toISOString().slice(0, 10);    
    return (
        <section id="events-1652">
            <div className="cs-container">
                <div className="cs-image">
                    <picture className="cs-picture">
                        <source media="(max-width: 600px)" srcSet="/images/temple-event.jpg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/temple-event.jpg"></source>
                        <img loading="lazy" decoding="async" src="/images/temple-event.jpg" alt="busines meeting" width="522" height="609" aria-hidden="true"></img>
                    </picture>
                </div>
                <div className="cs-events">
                    <div className="cs-content">
                        <span className="cs-topper">Temple Events</span>
                        <h2 className="cs-title">Upcoming Events</h2>
                    </div>
                    <ul className="cs-card-group">
                    {templeevent.map((event, index) => 
                        (event.display && event.WeeklySatsang) ? (
                            <li className="cs-item" key={index}>
                                <span className="cs-date">
                                <img src="/images/krishna-background.jpg" alt="temple event" width="100" height="100">
                                </img>
                                </span>
                                <div className="cs-info-wrapper cs-item cs-weekly-satsang">
                                <div className="cs-info">
                                    <h3 className="cs-h3">{event.title}</h3>
                                    <p className="cs-item-text">{event.description}</p>
                                    <span className="cs-location">{sundaydt}</span>
                                    <span className="cs-time">
                                    <img
                                        className="cs-icon"
                                        src="/images/gold-clock.svg"
                                        alt="icon"
                                        width="24"
                                        height="24"
                                        loading="lazy"
                                        decoding="async"
                                        aria-hidden="true"
                                    ></img>
                                    {event.time}
                                    </span>
                                </div>
                                <div className="cs-button-wrapper">
                                    <a href={event.details} className="cs-button-solid">
                                        Know More
                                    </a>
                                </div>
                                </div>
                            </li>
                        ) : event.display ? (
                            <li className="cs-item" key={index}>
                                <span className="cs-date">
                                <img src="/images/krishna-background.jpg" alt="Kirshna  temple event" width="100" height="100">
                                </img>
                                </span>
                                <div className="cs-info-wrapper">
                                <div className="cs-info">
                                    <h3 className="cs-h3">{event.title}</h3>
                                    <p className="cs-item-text">{event.description}</p>
                                    <span className="cs-location">{event.date}</span>
                                    <span className="cs-time">
                                    <img
                                        className="cs-icon"
                                        src="/images/gold-clock.svg"
                                        alt="icon"
                                        width="24"
                                        height="24"
                                        loading="lazy"
                                        decoding="async"
                                        aria-hidden="true"
                                    ></img>
                                    {event.time}
                                    </span>
                                </div>
                                <div className="cs-button-wrapper">
                                    <a href={event.details} className="cs-button-solid" target="_blank" rel="noopener noreferrer">
                                        Know More
                                    </a>
                                </div>
                                </div>
                            </li>
                        ): null
                        )}
                    </ul>
                </div>
            </div> 
        </section>                   
    )
}
export default Kevents
                                